var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.valid)?_c('div',[_c('v-switch',{model:{value:(_vm.confirmed),callback:function ($$v) {_vm.confirmed=$$v},expression:"confirmed"}},[_vm._v("Confirm")]),_c('v-btn',{attrs:{"outlined":"","loading":_vm.loading,"disabled":!_vm.confirmed},on:{"click":_vm.submit}},[_vm._v("Delete")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }